module.exports = __webpack_public_path__ + "img/border1.b419ec4.png";